import LojaModel from "../../model/LojaModel";
import ObaBaseDAO from "./ObaBaseDAO";
import ProdutoDescricaoModel from "../../model/ProdutoDescricaoModel";

class ObaInfoNutricionalDAO extends ObaBaseDAO {
  private static instance: ObaInfoNutricionalDAO;

  private endpoint = `${super.getBasePath()}/produto/infoNutricional`;

  private constructor() {
    super();
  }

  public static getInstance(): ObaInfoNutricionalDAO {
    if (!ObaInfoNutricionalDAO.instance) {
      ObaInfoNutricionalDAO.instance = new ObaInfoNutricionalDAO();
    }
    return ObaInfoNutricionalDAO.instance;
  }

  public async getByIdProdutoEstadoLoja(
    sku: string,
    loja: LojaModel
  ): Promise<ProdutoDescricaoModel> {
    return this.get(
      `REQ_OBA_INFO_NUTRICIONAL_${sku}`,
      `${this.endpoint}/${sku}/${loja.uf}`
    ).then((r: any) => this.toProdutoDescricaoModel(r.data));
  }

  public toProdutoDescricaoModel(item: any): ProdutoDescricaoModel {
    return {
      descricaoId: "99",
      titulo: "Informação nutricional",
      descricao: `Quantidade por porção de ${item.qtdporcao}g
        <table cellPadding="0" cellSpacing="0">
          <tr>
            <th className="col-1">
            </th>
            <th className="col-2">
              Qtd por porção
            </th>
            <th className="col-2">
              % VD (*)
            </th>
          </tr>
          <tr>
            <td>Valor energético</td>
            <td>${item.valorenergetico} kcal</td>
            <td>${item.vlrDValorEnergetico}%</td>
          </tr>
          <tr>
            <td>Carboidratos</td>
            <td>${item.carboidrato} g</td>
            <td>${item.vlrDCarboidrato}%</td>
          </tr>
          <tr>
            <td>Proteinas</td>
            <td>${item.proteina} g</td>
            <td>${item.vlrDProteina}%</td>
          </tr>
          <tr>
            <td>Gorduras totais</td>
            <td>${item.gorduratotal} g</td>
            <td>${item.vlrDGorduraTotal}%</td>
          </tr>
          <tr>
            <td>Gorduras saturadas</td>
            <td>${item.gordurasaturada} g</td>
            <td>${item.vlrDGorduraSaturada}%</td>
          </tr>
          <tr>
            <td>Gorduras trans</td>
            <td>${item.gorduratrans} g</td>
            <td>${item.vlrDGorduraTrans}%</td>
          </tr>
          <tr>
            <td>Fibra alimentar</td>
            <td>${item.fibraalimentar} g</td>
            <td>${item.vlrDFibraAlimentar} g</td>
          </tr>
          <tr>
            <td>Sódio</td>
            <td>${item.sodio} g</td>
            <td>${item.vlrDSodio} g</td>
          </tr>
        </table>

        ${item.observacao}
        (*) % Valores Diários com base em uma dieta de 2.000 kcal ou 8400 Kj.
        Seus valores diários podem ser maiores ou menores dependendo das
        suas necessidades energéticas.
        `,
    } as ProdutoDescricaoModel;
  }
}

export default ObaInfoNutricionalDAO;
